import { render, staticRenderFns } from "./TemplateConfig.vue?vue&type=template&id=79e90dd2&scoped=true"
import script from "./TemplateConfig.vue?vue&type=script&lang=js"
export * from "./TemplateConfig.vue?vue&type=script&lang=js"
import style0 from "./TemplateConfig.vue?vue&type=style&index=0&id=79e90dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e90dd2",
  null
  
)

export default component.exports